import angular from "angular";
import core from "../../core/core.module";
import organization from "../organization";
import payment from "../payment";

angular
    .module('organizationsControl.refillBalanceForm', [core, organization, payment])
    .component('refillBalanceForm', {
        controller: ['notifier', 'Organization', 'Payment', controller],
        template: require('./refill-balance-form.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&',
        }
    });

function controller(notifier, Organization, Payment) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $ctrl.agregatorBalance = $ctrl.resolve.agregatorBalance || 0;
        $ctrl.organization = $ctrl.resolve.organization;

        $ctrl.sum = 0;
        $ctrl.type = null;
        $ctrl.docType = null;
        $ctrl.docNumber = null;
        $ctrl.bankNumber = null;
        $ctrl.comment = null;

    };

    $ctrl.changeType = function () {
        $ctrl.docType = null;
        $ctrl.docNumber = null;
        $ctrl.bankNumber = null;
        $ctrl.comment = null;
    };

    $ctrl.submit = function () {
        $ctrl.loading = true;
        Payment
            .store({
                organizationId: $ctrl.organization.id,
                sum: $ctrl.sum,
                type: $ctrl.type,
                docType: $ctrl.docType,
                docNumber: $ctrl.docNumber,
                bankNumber: $ctrl.bankNumber,
                comment: $ctrl.comment
            })
            .then(
                function (response) {
                    $ctrl.loading = false;
                    notifier.successNotify('Транзацкия успешно встала в очередь', 1000);
                    $ctrl.close({
                        $value: {
                            transactionId: response.data.transactionId
                        }
                    });
                },
                function (error) {
                    $ctrl.loading = false;
                    notifier.errorResponseNotify(error);
                }
            );
    };

}

export default 'organizationsControl.refillBalanceForm';


// WEBPACK FOOTER //
// ./resources/assets/modules/organizations-control/refill-balance-form/refill-balance-form.js